module.exports = __webpack_public_path__ + "img/module6_7.5779acda.png";